import {
  IconHome2,
  IconHome,
  IconBackpack,
  IconBooks,
  IconListCheck,
  IconChartDonut,
  IconChartDonut3,
  IconCalendarEvent,
  IconClipboardCheck,
  IconClipboardList,
  IconClipboardText,
  IconFileAnalytics,
  IconFolder,
  IconNews,
  IconUsers,
  IconBook,
  IconBook2,
  IconReportAnalytics,
  IconSettings,
} from '@tabler/icons-react'
import { useFeatureToggle } from 'hooks'
import { SidebarMenuIconProps } from './interfaces'

const legacyIconMapping = {
  'icon-home': IconHome2,
  'icon-activities': IconBackpack,
  'icon-mosaic': IconChartDonut3,
  'icon-pendencies': IconListCheck,
  'icon-timetable-manager': IconCalendarEvent,
  'icon-reports': IconClipboardText,
  'icon-tasks-tracker': IconClipboardCheck,
  'icon-observations': IconNews,
  'icon-students': IconUsers,
  'icon-pen-ruler': IconBook,
  'icon-students-report': IconReportAnalytics,
  'icon-md-settings': IconSettings,
  'icon-resource-center': IconBook2,
}

// Arc swaps the sidebar icon set for the prototype one (AR-578) while the
// legacy mapping stays byte-identical when the flag is off.
const arcIconMapping = {
  ...legacyIconMapping,
  'icon-home': IconHome,
  'icon-activities': IconFolder,
  'icon-mosaic': IconChartDonut,
  'icon-pendencies': IconClipboardList,
  'icon-tasks-tracker': IconClipboardList,
  'icon-reports': IconFileAnalytics,
  'icon-students-report': IconFileAnalytics,
  'icon-resource-center': IconBooks,
}

export const SidebarMenuIcon = ({ icon, size }: SidebarMenuIconProps) => {
  const isArcMosaico = useFeatureToggle('arc-mosaico-project') as boolean

  const mapping = isArcMosaico ? arcIconMapping : legacyIconMapping
  const IconComponent = mapping[icon as keyof typeof mapping] || (isArcMosaico ? IconHome : IconHome2)

  return <IconComponent size={size} />
}
